export default __webpack_public_path__ + "static/media/ticket-fill.6877392d.svg";